import { h } from 'preact';

const Tiktok = (props) => {
	return (
		<svg {...props} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<g id="Icon/Social/TikTok" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g id="tiktok-share-icon-black-1" transform="translate(5.000000, 3.000000)" fill={props.fill} fill-rule="nonzero">
					<path d="M13.8605714,7.47028571 C13.7295209,7.48302011 13.5979521,7.48969389 13.4662857,7.49028571 C12.0220807,7.49048733 10.6751128,6.76253596 9.884,5.55428571 L9.884,12.1468571 C9.884,14.837904 7.70247546,17.0194286 5.01142857,17.0194286 C2.32038168,17.0194286 0.138857143,14.837904 0.138857143,12.1468571 C0.138857143,9.45581025 2.32038168,7.27428571 5.01142857,7.27428571 C5.11314286,7.27428571 5.21257143,7.28342857 5.31257143,7.28971429 L5.31257143,9.69085714 C5.21257143,9.67885714 5.11428571,9.66057143 5.01142857,9.66057143 C3.6379753,9.66057143 2.52457143,10.7739753 2.52457143,12.1474286 C2.52457143,13.5208818 3.6379753,14.6342857 5.01142857,14.6342857 C6.38514286,14.6342857 7.59828571,13.552 7.59828571,12.1782857 L7.62228571,0.981714286 L9.91942857,0.981714286 C10.1360407,3.04167703 11.7970496,4.6506966 13.8628571,4.80171429 L13.8628571,7.47028571"></path>
				</g>
			</g>
		</svg>
	);
};

export default Tiktok;
